import { environment } from "@environments/environment";
import {
  HttpHandler,
  HttpHeaderResponse,
  HttpInterceptor,
  HttpProgressEvent,
  HttpRequest,
  HttpResponse,
  HttpSentEvent,
  HttpUserEvent,
} from "@angular/common/http";
import { from, Observable, of } from "rxjs";
import { AuthenticationService } from "./authentication.service";
import { MsalService } from "@azure/msal-angular";
import { catchError, mergeMap } from "rxjs/operators";
import { Injectable } from "@angular/core";
const scope = environment.api.scope;


@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private auth: AuthenticationService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<
    | HttpSentEvent
    | HttpHeaderResponse
    | HttpProgressEvent
    | HttpResponse<any>
    | HttpUserEvent<any>
  > {
    const s = this.auth.msalService as MsalService;

    const request = from(
      s.acquireTokenSilent({
        scopes: [`${scope}`],
      })
    );


    return request.pipe(
      mergeMap((response) => {
        const nextReq = req.clone({
          headers: req.headers.set(
            "authorization",
            `Bearer ${response.accessToken}`
          )
          .set(
            environment.api.subscriptionHeader,
            environment.api.subscriptionKey
          )
          .set(
            "Strict-Transport-Security", "max-age=7200"
          )
        });
        return next.handle(nextReq);
      }),
      catchError(() => {
        return next.handle(req);
      })
    );
  }
}
